module.exports = __webpack_public_path__ + "static/media/sign-up_mobile.0eb427a8.png";